module.exports = __webpack_public_path__ + "8040b7caa5d22b40be877d4258abb139.svg";